import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Olberic Single Story Endless Items Cait route" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Iron Sword`}</strong>{` + `}<strong parentName="p">{`War Spear`}</strong><br parentName="p"></br>{`
`}{`Challenge two dudes: Spear, Spearx2`}<br parentName="p"></br>{`
`}{`Sword on 2 break guy -> Level Slash -> Level Slash x4`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Fire S`}</strong>{` if no Wind S drop earlier.`}<br parentName="p"></br>{`
`}{`Heal to full before Gaston`}</p>
    <h4 {...{
      "id": "gaston"
    }}>{`Gaston`}</h4>
    <ol>
      <li parentName="ol">{`Level Slash`}</li>
      <li parentName="ol">{`Fire/Wind Soulstone`}</li>
      <li parentName="ol">{`Light Soulstone`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`4xSpear`}</li>
      <li parentName="ol">{`3xSpear`}</li>
      <li parentName="ol">{`Heal`}</li>
      <li parentName="ol">{`Spear`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`4xSpear`}</li>
      <li parentName="ol">{`Spear`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <p>{`Thousand Spears`}</p>
    </Menu>
    <p>{`Go to Scholar Shrine, kill Cait on the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <p>{`Lightning Bolt, Analyze`}</p>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <p>{`Evasive Maneuvers`}</p>
    </Menu>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700
    }}>GO TO PURGATION</strong>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Old Coin`}</strong>{`, tag `}<strong parentName="p">{`Sunshade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Bolderfall`}</strong>{`. Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{` + `}<strong parentName="p">{`Olive L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, start Ch.2, TP `}<strong parentName="p">{`Rippletide`}</strong>{` when back on 1st screen.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <p>{`Light L.`}</p>
    <p>{`Head towards `}<strong parentName="p">{`Merchant Shrine`}</strong>{`. Pick `}<strong parentName="p">{`$1200`}</strong>{`. Get `}<strong parentName="p">{`Merchant Shrine`}</strong></p>
    <p>{`TP `}<strong parentName="p">{`Cobblestone`}</strong>{`, go to Runeblade.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light M`}</strong>{`, `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <p>{`Light L`}</p>
    <p>{`Go to `}<strong parentName="p">{`Wellspring`}</strong>{`, pick `}<strong parentName="p">{`Fire L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`0 Stones available for use`}</p>
    </blockquote>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Fire L + Ice M + Light M`}</p>
    <p>{`Steal `}<strong parentName="p">{`Pom S, Nourishing Nut`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Warrior`}</strong>{`, `}<strong style={{
            color: 'red'
          }}>{`Cross Strike`}</strong></li>
        <li parentName="ul">{`Tressa: Hired Help, `}<strong parentName="li">{`Scholar`}</strong>{`, Lightning Blast`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Bolderfall Battle: Condors Spear / Bow, everything else Bandits. Condors have 1500HP`}</p>
    </blockquote>
    <p>{`Head towards `}<strong parentName="p">{`Riverford`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Pom S`}</strong>{`, break / run from battle. Sword on 4S guy, Dagger / Spear on 1S guy.`}<br parentName="p"></br>{`
`}{`Challenge run from guy to reset steps.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Riverford`}</strong>{`. Buy `}<strong parentName="p">{`Fire M`}</strong>{` and `}<strong parentName="p">{`Wind M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Loot Refuge Ruins.`}</p>
    <p>{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`. Go to Catacombs.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Viper Dagger`}</strong>{`, `}<strong parentName="p">{`Master Spear`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Marsalim`}</strong>{`. Buy 3 L Stones, pick 3 chests.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, continue Olberic Ch.2.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nourish S: Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Optimize`}</li>
        <li parentName="ul">{`Tressa: Enchanted Rod`}</li>
        <li parentName="ul">{`Therion: Viper Dagger`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <h4 {...{
      "id": "right-challenge"
    }}>{`Right Challenge`}</h4>
    <ol>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`Sword x2`}</li>
      <li parentName="ol">{`Cross Strike x4 (Swordx2 after if needed)`}</li>
    </ol>
    <h4 {...{
      "id": "left-challenge"
    }}>{`Left Challenge`}</h4>
    <ol>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`Thousand Spears`}</li>
      <li parentName="ol">{`Thousand Spears x4`}</li>
    </ol>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>Buy 2 Shadow M.</strong>
    <h4 {...{
      "id": "victorino---12718---sword-dagger-wind-dark"
    }}>{`Victorino - 12718 - Sword, Dagger, Wind, Dark`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Tressa: Attack / Nothing`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Therion: HHM x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike Victorino`}</li>
      <li parentName="ul">{`Tressa: Shadow M`}</li>
      <li parentName="ul">{`Primrose: Attack x3 Victorino`}</li>
      <li parentName="ul">{`Therion: Shadow M`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Therion: Attack x2`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast x4`}</li>
    </ul>
    <h4 {...{
      "id": "joshua---18184---axe-staff-fire-light---ice-m-30-x2"
    }}>{`Joshua - 18184 - Axe, Staff, Fire, Light - Ice M 30% x2`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Defend x2`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Therion: HHM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Pom S Therion`}</li>
      <li parentName="ul">{`Tressa: Staff x3 `}{`[L]`}</li>
      <li parentName="ul">{`Primrose: Axe x3 `}{`[R]`}</li>
      <li parentName="ul">{`Therion: HHV x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Watch for M Stone drop, this affects whether or not you buy stones early in Riverford.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help, `}<strong parentName="li">{`Hunter`}</strong></li>
        <li parentName="ul">{`Therion: HP Thief + Armor Corrosive, `}<strong parentName="li">{`Merchant`}</strong>{`, Rest`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Sidestep, Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: EI, Cover`}</li>
        <li parentName="ul">{`Everyone Else: EI`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "archibold---20182---dagger-bow-ice-dark"
    }}>{`Archibold - 20182 - Dagger, Bow, Ice, Dark`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Throw Shadow L before Fire L`}<br parentName="p"></br>{`
`}{`Notes are for 3T, if unlucky fight adjust to 4T`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHM`}</li>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Others: Shadow L + Fire L`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Blizzard`}</strong></li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Attack x4`}</li>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast x4`}</li>
      <li parentName="ul">{`Therion: HP Thief x4`}</li>
    </ul>
    <h4 {...{
      "id": "gustav---39549---spear-axe-bow-fire-dark"
    }}>{`Gustav - 39549 - Spear, Axe, Bow, Fire, Dark`}</h4>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHV x2`}</li>
      <li parentName="ul">{`Merchant 2: `}<strong parentName="li">{`Spear`}</strong></li>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Primrose: Leghold Trap`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Thousand Spears`}</li>
      <li parentName="ul">{`Tressa: Spear`}</li>
      <li parentName="ul">{`Primrose: Axe x3 `}{`[R]`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Merchant 2: HHV x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`, Loot `}<strong parentName="p">{`Warbringer`}</strong>{`. If needed TP `}<strong parentName="p">{`Riverford`}</strong>{` and buy Ice Stones.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, finish chapter. TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <p>{`Talk to first 2 NPC, then Challenge 2nd NPC.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Challenge`}</strong>{`: Thousand Spears, Spearhead x3`}</p>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>Pick $23000</strong>
    <h4 {...{
      "id": "lizards-1"
    }}>{`Lizards #1`}</h4>
    <p>{`L + M`}</p>
    <h4 {...{
      "id": "lizards-2"
    }}>{`Lizards #2`}</h4>
    <p>{`Ice L + M OR L + Ice M + Blizzard x2 OR L + M + Blizzard x2 if no Hold Strong`}</p>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>Pick $6000</strong>
    <h4 {...{
      "id": "lizardman-chieftan---51868---sword-dagger-axe-lightning-light"
    }}>{`Lizardman Chieftan - 51868 - Sword, Dagger, Axe, Lightning, Light`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Sword x2`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Primrose: HHV x3`}</li>
      <li parentName="ul">{`Therion: Pom M Olberic`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Therion: HP Thief x2`}</li>
    </ul>
    <p style={{
      color: 'red',
      fontSize: '72px',
      fontWeight: 700
    }}>DO THIS MENU</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Hunter`}</strong></li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "erhardt---14819---sword-axe-ice-dark"
    }}>{`Erhardt - 14819 - Sword, Axe, Ice, Dark`}</h4>
    <ol>
      <li parentName="ol">{`HHM`}</li>
      <li parentName="ol">{`HHM`}</li>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`Swordx3`}</li>
      <li parentName="ol">{`HHVx3`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch4"
    }}>{`Olberic Ch.4`}</h3>
    <h4 {...{
      "id": "red-hat---24320---sword-axe-wind---thunder-m-80"
    }}>{`Red Hat - 24320 - Sword, Axe, Wind - Thunder M 80%`}</h4>
    <ol>
      <li parentName="ol">{`Wind L`}</li>
      <li parentName="ol">{`HHM`}</li>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`HHVx4`}</li>
      <li parentName="ol">{`L Stone`}</li>
    </ol>
    <p style={{
      color: 'red',
      fontSize: '72px',
      fontWeight: 700
    }}>PICK POUCH IN MANSE</p>
    <p>{`Buy `}<strong parentName="p">{`Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Unequip All`}</li>
        <li parentName="ul">{`Tressa: Remove Enchanted Rod `}{`[2D]`}</li>
        <li parentName="ul">{`Therion: Remove Viper Dagger `}{`[1D]`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <p>{`Sell until $119000`}</p>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`TODO: Fix this for Merchant Olberic`}</p>
    </blockquote>
    <h4 {...{
      "id": "werner---101396---dagger-axe-lightning-wind-light"
    }}>{`Werner - 101396 - Dagger, Axe, Lightning, Wind, Light`}</h4>
    <h5 {...{
      "id": "vet-counts"
    }}>{`Vet counts`}</h5>
    <p>{`16 - M, Light S before break, 2x Bandits killed by 140. Ideally 2M`}<br parentName="p"></br>{`
`}{`15 - L, maybe range?`}<br parentName="p"></br>{`
`}{`14 - L, M, Wind M to break`}</p>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Leghold`}</li>
      <li parentName="ul">{`Tressa: Olive / Sidestep / LB`}</li>
      <li parentName="ul">{`Primrose: Olive / Sidestep`}</li>
      <li parentName="ul">{`Therion: Dagger x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Axe x3 `}{`[2R]`}</li>
      <li parentName="ul">{`Tressa / Primrose: Sidestep / Pom / Olive`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Corrosive x2`}</li>
      <li parentName="ul">{`Merchants: HHV x4`}</li>
      <li parentName="ul">{`Olberic: Leghold`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Attack`}</li>
      <li parentName="ul">{`Tressa: Tradewinds / Pom L Merchant if Olberic Terrored or otherwise needed`}</li>
      <li parentName="ul">{`Primrose: Olive Therion`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Attack (x3)`}</li>
      <li parentName="ul">{`Merchants: Tradewinds / HHB x3 / Pom`}</li>
      <li parentName="ul">{`Therion: Wind M / Pom`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`HHVxMAX + Stones`}</li>
    </ul>
    <p>{`End after cutscene w/ Erhardt.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      